import { useCallback, useEffect, useRef } from 'react';

const useScrollToComponent = (componentRef, offset) => {
  const scrollToComponentRef = useRef(null);

  useEffect(() => {
    scrollToComponentRef.current = require('react-scroll-to-component');
  }, []);

  const scrollTo = useCallback(() => {
    if (!scrollToComponentRef || !componentRef) return;

    scrollToComponentRef.current(componentRef.current, {
      // Offset value is from the top of the screen
      offset: offset || -70,
      align: 'top',
      duration: 70,
    });
  }, [scrollToComponentRef, componentRef]);

  return scrollTo;
};

export default useScrollToComponent;
